<template>
  <div>
    <v-app-bar scroll-target="#scrolling-techniques-7" color="teal lighten-5">
      <v-app-bar-nav-icon @click="drawer = true"></v-app-bar-nav-icon>
      <div class="d-inline-flex pa-1">
        <v-img max-width="48" src="../assets/crisis_hotline.png"></v-img>
      </div>
      <div class="d-inline-flex">
        <div class="d-flex flex-column">
          <span class="text-h5 primary--text">
            Telemental Health Response
          </span>
        </div>
      </div>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" absolute temporary class="overflow-auto" height="100vh">
      <v-container class=".justify-center">
        <v-avatar color="indigo" size="180">
          <span class="white--text text-h2">{{ `${user.first_name[0]}${user.last_name[0]}`.toLocaleUpperCase() }}</span>
        </v-avatar>
      </v-container>
      <v-list two-line density="compact">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item v-bind="attrs" v-on="on">
          <v-list-item-icon>
            <v-icon color="blue-grey">
              mdi-badge-account
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-capitalize">
              {{ `${user.first_name} ${user.last_name}` }}
            </v-list-item-title>
            <v-list-item-subtitle>Name</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
         </template>
          <span class="text-capitalize">   {{ `${user.first_name} ${user.last_name}` }}</span>
        </v-tooltip>
        <v-list-item>
          <v-list-item-icon>
            <v-icon color="blue-grey">
              mdi-phone
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ user.mobile_number }}</v-list-item-title>
            <v-list-item-subtitle>Mobile</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item v-bind="attrs" v-on="on">
              <v-list-item-icon>
                <v-icon color="blue-grey">
                  mdi-at
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ user.email }}
                </v-list-item-title>
                <v-list-item-subtitle>Email</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
          <span>{{ user.email }}</span>
        </v-tooltip>
      </v-list>
      <v-divider></v-divider>
      <v-list rounded nav density="compact">
        <v-list-item-group active-class="secondary primary--text">
          <v-list-item v-if="role === 'Secretary' || role === 'Psychologist' || role === 'Counselor' || role === 'Psychiatrist'" @click="home">
            <v-list-item-icon>
              <v-icon color="accent">mdi-calendar</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Schedules</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="role === 'Secretary'" @click="audit_logs">
            <v-list-item-icon>
              <v-icon color="accent">mdi-file-document-multiple-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Audit logs</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="role === 'Psychologist' || role === 'Counselor' || role === 'Psychiatrist'" @click="provider_logs">
            <v-list-item-icon>
              <v-icon color="accent">mdi-file-document-multiple-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Previous schedules</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="role === 'Secretary'" @click="users">
            <v-list-item-icon>
              <v-icon color="accent">mdi-account-group-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Users</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="role !== 'Secretary'"  href="https://mentalhealthph.org/ncmhusaptayofeedback/" target="_blank">
            <v-list-item-icon>
              <v-icon color="accent">mdi-send-check</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Send us Feedback</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-icon>
              <v-icon color="accent">mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
import store from "../store";
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      drawer: false,
      userDetails: {
        last_name: "",
        middle_name: "",
        first_name: "",
        username: "",
        title: "",
        role: "",
        mobile_number: "",
        email: "",
      },
    };
  },
  computed: mapState({
    user: state => state.userDetails,
  }),
  methods: {
    home: function () {
      this.$router.push("/");
    },
    user_notes: function () {
      this.$router.push("/user_notes");
    },
    audit_logs: function () {
      this.$router.push("/audit_logs");
    },
    provider_logs: function () {
      this.$router.push("/provider_logs");
    },
    users: function () {
      this.$router.push("/users");
    },
    logout: function () {
      this.$store.dispatch("logout").then(() => this.$router.push("/login"));
    },
    get_current_local_time: function () {
      return moment().format('LLLL');
    }
  },
  created() {
    this.$store.dispatch("userDetails", store.getters.getJwt)
    this.role = store.getters.getUserRole;
    this.userName = store.getters.getUserRole;
  }

};
</script>

